import api from '@api'

import {
  getRootTranslator,
  getRootPluaralTranslator,
} from '@utils/get-module-translator'
import {
  transformBinaryQualForServer,
  buildRelationalQualificationStructure,
} from '@data/qualification'

const __rootT = getRootTranslator()
const __rootTc = getRootPluaralTranslator()

const transformRelationType = (type) => ({
  id: type.id,
  directName: type.directName,
  inverseName: type.inverseName,
  description: type.description,
  canEdit: type.updatebleOob,
  canDelete: type.deleteableOob,
})

const transformRelationTypeForServer = (type) => ({
  id: type.id,
  directName: type.directName,
  inverseName: type.inverseName,
  description: type.description,
})

export function getRelationshipTypesApi(
  searchTerm,
  limit,
  offset,
  sortedColumn
) {
  return api
    .post(
      `/assetrelationtype/search/byqual`,
      {
        qualDetails: searchTerm
          ? transformBinaryQualForServer(
              buildRelationalQualificationStructure(
                'directName',
                'contains',
                searchTerm,
                'string',
                'db'
              ),
              buildRelationalQualificationStructure(
                'inverseName',
                'contains',
                searchTerm,
                'string',
                'db'
              ),
              'or'
            )
          : undefined,
      },
      {
        params: {
          offset: offset || 0,
          size: limit === undefined ? 1000 : limit,
          ...(sortedColumn ? { sort_by: sortedColumn } : {}),
        },
      }
    )
    .then((data) => {
      return {
        items: (data.objectList || []).map(transformRelationType),
        total: data.totalCount,
      }
    })
}

export function createRelationshipTypeApi(contract) {
  return api
    .post(`/assetrelationtype`, transformRelationTypeForServer(contract), {
      message: __rootT('added_successfully', {
        resource: __rootTc('relationship_type', 1),
      }),
    })
    .then(transformRelationType)
}

export function deleteRelationshipTypeApi(id) {
  return api.delete(`/assetrelationtype/${id}`, {
    message: __rootT('removed_successfully', {
      resource: __rootTc('relationship_type', 1),
    }),
  })
}

export function updateRelationshipTypeApi(contract) {
  return api
    .patch(
      `/assetrelationtype/${contract.id}`,
      transformRelationTypeForServer(contract),
      {
        message: __rootT('updated_successfully', {
          resource: __rootTc('relationship_type', 1),
        }),
      }
    )
    .then(transformRelationType)
}
